import {
  format,
  formatDistance,
  formatRelative,
  fromUnixTime,
  formatDistanceToNow,
} from 'date-fns'

export default {
  methods: {
    formatDate(ts, fm, options) {
      return format(fromUnixTime(ts), fm, options)
    },
    formatDistance(ts, ts2, options) {
      return formatDistance(fromUnixTime(ts), fromUnixTime(ts2), options)
    },
    formatDistanceToNow(ts, options) {
      return formatDistanceToNow(fromUnixTime(ts), options)
    },
    formatRelative(ts, ts2, options) {
      return formatRelative(fromUnixTime(ts), fromUnixTime(ts2), options)
    },
    formatRelativeToNow(ts, options) {
      return formatRelative(fromUnixTime(ts), new Date(), options)
    },
  },
}
